export const MEASUREMENT_TYPES = {
    WEIGHT: 'weight',
    HIP: 'hip',
    WAIST: 'waist',
    THIGH: 'thigh',
    CHEST: 'chest',
    ARM: 'arm',
};
